//
import Service from '@/services/api/service'
import CustomerAccountReceivableModel from '@/models/Sale/SlCustomerAccountReceivable'

/**
 * This class describes a sl customer account receivable.
 *
 * @class      SlCustomerAccountReceivable (name)
 */
export default class SlCustomerAccountReceivable extends Service {

  /**
   * The sl customer account receivable includes
   */
  static includes = [
    'sl_customer_account',
    'sl_customer_account.sl_customer',
    'sl_sale_invoice',
  ]

  /**
   * the sl customer account receivable model
   */
  static model = CustomerAccountReceivableModel
}
